import { Constants } from "../Engines/constants";
/**
 * Abstract class used to decouple action Manager from scene and meshes.
 * Do not instantiate.
 * @see http://doc.babylonjs.com/how_to/how_to_use_actions
 */

var AbstractActionManager =
/** @class */
function () {
  function AbstractActionManager() {
    /** Gets the cursor to use when hovering items */
    this.hoverCursor = '';
    /** Gets the list of actions */

    this.actions = new Array();
    /**
     * Gets or sets a boolean indicating that the manager is recursive meaning that it can trigger action from children
     */

    this.isRecursive = false;
  }

  Object.defineProperty(AbstractActionManager, "HasTriggers", {
    /**
     * Does exist one action manager with at least one trigger
     **/
    get: function get() {
      for (var t in AbstractActionManager.Triggers) {
        if (AbstractActionManager.Triggers.hasOwnProperty(t)) {
          return true;
        }
      }

      return false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AbstractActionManager, "HasPickTriggers", {
    /**
     * Does exist one action manager with at least one pick trigger
     **/
    get: function get() {
      for (var t in AbstractActionManager.Triggers) {
        if (AbstractActionManager.Triggers.hasOwnProperty(t)) {
          var t_int = parseInt(t);

          if (t_int >= Constants.ACTION_OnPickTrigger && t_int <= Constants.ACTION_OnPickUpTrigger) {
            return true;
          }
        }
      }

      return false;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Does exist one action manager that handles actions of a given trigger
   * @param trigger defines the trigger to be tested
   * @return a boolean indicating whether the trigger is handeled by at least one action manager
  **/

  AbstractActionManager.HasSpecificTrigger = function (trigger) {
    for (var t in AbstractActionManager.Triggers) {
      if (AbstractActionManager.Triggers.hasOwnProperty(t)) {
        var t_int = parseInt(t);

        if (t_int === trigger) {
          return true;
        }
      }
    }

    return false;
  };
  /** Gets the list of active triggers */


  AbstractActionManager.Triggers = {};
  return AbstractActionManager;
}();

export { AbstractActionManager };